"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid6"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var resourceFields = ['displayOptions.resources.showPageControls', 'displayOptions.resources.showThumbnail', 'displayOptions.resources.showDescription', 'displayOptions.resources.showTags', 'displayOptions.resources.showShareButton', 'displayOptions.resources.showShareIconOnly', 'displayOptions.resources.uppercaseTitle', 'displayOptions.resources.titleColor', 'displayOptions.resources.shareButtonColor', 'displayOptions.resources.renderMode', 'displayOptions.resources.coverThumbnails', 'displayOptions.resources.showFilterGroupIcons', 'displayOptions.resources.hideSearchBar', 'displayOptions.resources.hideShowingResources', 'displayOptions.resources.hidePerPageDropdown', 'displayOptions.resources.hideDisplayLayoutToggle'];
var fields = exports.fields = [].concat(resourceFields);
var _default = exports["default"] = function _default(props) {
  var displayOptions = props.fields.displayOptions;
  var defaultPerPageOption = displayOptions.portal.defaultPerPageOption;
  var _displayOptions$resou = displayOptions.resources,
    showPageControls = _displayOptions$resou.showPageControls,
    showThumbnail = _displayOptions$resou.showThumbnail,
    showDescription = _displayOptions$resou.showDescription,
    showTags = _displayOptions$resou.showTags,
    showShareButton = _displayOptions$resou.showShareButton,
    showShareIconOnly = _displayOptions$resou.showShareIconOnly,
    uppercaseTitle = _displayOptions$resou.uppercaseTitle,
    renderMode = _displayOptions$resou.renderMode,
    coverThumbnails = _displayOptions$resou.coverThumbnails,
    showFilterGroupIcons = _displayOptions$resou.showFilterGroupIcons,
    hideSearchBar = _displayOptions$resou.hideSearchBar,
    hideShowingResources = _displayOptions$resou.hideShowingResources,
    hidePerPageDropdown = _displayOptions$resou.hidePerPageDropdown,
    hideDisplayLayoutToggle = _displayOptions$resou.hideDisplayLayoutToggle;
  var resourceOptions = [{
    field: showThumbnail,
    label: 'Show Thumbnail'
  }, {
    field: showDescription,
    label: 'Show Description'
  }, {
    field: showTags,
    label: 'Show Tags'
  }, {
    field: showShareButton,
    label: 'Show Share Button'
  }, {
    field: showShareIconOnly,
    label: 'Show Share Icon Only'
  }, {
    field: uppercaseTitle,
    label: 'Uppercase Title'
  }, {
    field: coverThumbnails,
    label: 'Cover Thumbnails',
    tooltip: 'Thumbnail will cover entire left side or entire top of the resource.'
  }, {
    field: showFilterGroupIcons,
    label: 'Show Filter Group Icons'
  }];
  var showPage = [{
    field: showPageControls,
    label: 'Show Page Controls',
    tooltip: 'This will remove pagination, which may hide some resources from view. Only' + ' turn this off if the number of resources will be less than the Resorces Per Page listed above.'
  }];
  var showPageControlOptions = [{
    field: hideSearchBar,
    label: 'Hide Search Bar'
  }, {
    field: hideShowingResources,
    label: 'Hide Showing X of Y Resources'
  }, {
    field: hidePerPageDropdown,
    label: 'Hide Per Page Dropdown'
  }, {
    field: hideDisplayLayoutToggle,
    label: 'Hide Display Layout'
  }];
  var perPageOptions = [{
    value: 5,
    label: '5'
  }, {
    value: 10,
    label: '10'
  }, {
    value: 15,
    label: '15'
  }, {
    value: 25,
    label: '25'
  }, {
    value: 50,
    label: '50'
  }];
  var renderModeOptions = [{
    value: 'list',
    label: 'List'
  }, {
    value: 'grid',
    label: 'Grid'
  }];

  // Prevent breaking change from adding the new key showPageControls
  if (![true, false].includes(showPageControls.value)) {
    showPageControls.onChange(true);
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "well"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: defaultPerPageOption,
    label: "Resources Per page"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-control",
    value: defaultPerPageOption.value,
    onChange: function onChange(e) {
      return defaultPerPageOption.onChange(Number(e.target.value));
    },
    style: {
      width: 'auto'
    }
  }, perPageOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    role: "group",
    "aria-label": "..."
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "resourceDisplay"
  }, "Resources Display"), /*#__PURE__*/_react["default"].createElement("div", {
    id: "resourceDisplay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group"
  }, renderModeOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: option.value,
      type: "button",
      className: 'btn btn-default ' + (option.value === renderMode.value ? 'active' : ''),
      onClick: function onClick() {
        renderMode.onChange(option.value);
      }
    }, option.value === 'list' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "List ", /*#__PURE__*/_react["default"].createElement(_menu["default"], null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Grid ", /*#__PURE__*/_react["default"].createElement(_grid["default"], null)));
  })))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: {
      marginBottom: '-15px'
    }
  }, resourceOptions.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-xs-3",
      key: resource.label,
      style: {
        marginBottom: '15px'
      }
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "pageControls"
  }, "Page Controls"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "column"
  }, showPage.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: resource.label,
      style: {
        marginBottom: '15px'
      }
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  }), showPageControls.checked === true ? showPageControlOptions.map(function (resource) {
    return /*#__PURE__*/_react["default"].createElement("h6", {
      key: resource.label
    }, resource.tooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: /*#__PURE__*/_react["default"].createElement("span", null, resource.label, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: resource.tooltip
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
      value: resource.field.value,
      onChange: function onChange() {
        return resource.field.onChange(!resource.field.value);
      },
      label: resource.label
    }));
  }) : null));
};